const consumablesMasterColumns = () => {
  return (
    [
      {
        Header: 'Display Sequence',
        accessor: 'displayseq',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Consumables Id',
        accessor: 'consumablecodeext',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Consumables',
        accessor: 'consumabledescription',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Line Sequence',
        accessor: 'lineseq',
        editType: 'inputField',
        options: []
      },
      {
        Header: 'Raw Material',
        accessor: 'billetid',
        editType: 'Combobox',
        options: []
      },
      {
        Header: 'Lifetime',
        accessor: 'lifetime',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Profiles',
        accessor: 'productprofiles',
        editType: null,
        options: []
      },
      {
        Header: 'Quantity Installed',
        accessor: 'quantityinstalled',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Quantity Redressed',
        accessor: 'quantityredressed',
        editType: 'Number',
        options: []
      },
      {
        Header: 'Active ?',
        accessor: 'isactive',
        editType: 'Boolean',
        options: []
      },
      {
        Header: 'Remarks',
        accessor: 'remarks',
        editType: 'inputField',
        options: []
      },

    ]
  )
}

export default consumablesMasterColumns;
